/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InvestmentAgreement } from './investment-agreement';
import { DeckCreateInvestmentPaymentOption } from './deck-create-investment-payment-option';
import { InvestmentStatusEnum } from './investment-status-enum';

export interface DeckCreateInvestment {
  readonly id: string;
  readonly amount: string | null;
  readonly pitch: string;
  readonly status: InvestmentStatusEnum;
  readonly company_name: string;
  readonly pitch_slug: string;
  readonly company: string;
  readonly equity_received: number | null;
  readonly investment_company: string | null;
  readonly investment_company_name: string;
  readonly user_name: string;
  readonly contact_email: string;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  payment_option: DeckCreateInvestmentPaymentOption | null;
  readonly account_number: string | null;
  readonly vps: string | null;
  readonly agreements: Array<InvestmentAgreement>;
  readonly rejection_reason: string | null;
  readonly compensation: string | null;
  readonly user: string;
}
export namespace DeckCreateInvestment {}
